import React from "react";
import './HotelBooking.css'


const HotelBooking = ()=>{
    return(
        <h1>This is hotel booking page.</h1>
    );
};

export default HotelBooking;